<template>
  <div>
    <div class="row" v-if="loaded">
      <div class="col-md-3">
        <div class="card card-primary pull-right">
          <div
            class="card-heading"
            style="padding: 15px; font-size: 18px; font-weight: bold"
          >
            Configurar Posições
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-12 centered">
                <button class="btn btn-add pull-right" @click="addPlace">
                  <i class="fas fa-map-pin"></i> Nova Posição
                </button>

                <button class="btn btn-add pull-right m-r-sm" @click="save">
                  <i class="fas fa-save"></i> Salvar Posições
                </button>

                <!-- <button
                    class="btn btn-add pull-right mt-2"
                    @click="openModalPlace"
                  >
                    <i class="far fa-edit"></i> Editar Posição
                  </button> -->
              </div>
              <div class="col-md-12 centered">
                <router-link
                  to="/workstations"
                  class="btn btn-back centered mt-3"
                >
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
              </div>

              <div class="col-md-12 centered mt-3"></div>
            </div>
          </div>
        </div>
        <div
          class="card card-primary pull-right"
          v-if="Object.keys(elementSelected).length"
        >
          <div
            class="card-heading"
            style="padding: 15px; font-size: 18px; font-weight: bold"
          >
            Editar Posição
          </div>

          <div class="row justify-content-center">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-12">
                  <label for="position-title">Nome da Posição:</label>
                  <input
                    type="text"
                    id="position-title"
                    class="form-control"
                    v-model="elementSelected.title"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-11 mt-3">
              <div class="form-group">
                <label for="WorkstationDetails">Contém na Posição:</label>
                <br />
              </div>
            </div>
            <div
              class="col-md-4 mt-1 mb-1 ml-1 mr-1 centered"
              style="text-align: center; lg-check"
              v-for="detail in details"
              :key="detail.id"
            >
              <input
                type="checkbox"
                :value="detail.id"
                v-model="checkeds"
                :id="detail.id"
              />
              <label :for="detail.id">{{ detail.title }}</label>
            </div>

            <div class="col-md-12 mt-3 mb-3 centered">
              <button
                type="button"
                class="btn btn-add"
                data-dismiss="modal"
                @click="savePosition(elementSelected.id)"
              >
                <i class="fas fa-save"></i> Salvar
              </button>
            </div>

            <div class="col-md-11">
              <div class="row centered">
                <div class="col-md-12 mt-3 mb-3">
                  <button
                    type="button"
                    class="btn btn-delete"
                    data-dismiss="modal"
                    @click="removeComponent(selected)"
                  >
                    <i class="fas fa-trash"></i> Deletar Posição
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div class="card">
            <div
              class="card-heading"
              style="padding: 15px; font-size: 18px; font-weight: bold"
            >
              Workstation {{ workstation.title }}
            </div>
            <div class="card-body">
              <div
                class="top-container"
                style="border: 0px solid #f0f0f0; margin-top: -15px"
              >
                <img
                  :src="workstation.blueprint"
                  v-on:load="onLoaded"
                  class="image-size img-responsive"
                  style="top: 0; left: 0"
                />
                <VueDragResize
                  ref="draggable"
                  v-for="(element, index) in elements"
                  :key="index"
                  :isActive="true"
                  :w="40"
                  :h="28"
                  :x="parseFloat(element.left)"
                  :y="parseFloat(element.top)"
                  :minw="60"
                  :minh="50"
                  v-on:resizing="resize($event, index)"
                  v-on:dragging="resize($event, index)"
                  :parentLimitation="true"
                  class="text-center"
                  :isResizable="false"
                  @clicked="selectPlace(index, element)"
                >
                  <button
                    type="button"
                    :class="
                      isSelected && index == selected
                        ? 'btn btn-info'
                        : 'btn btn-secondary'
                    "
                    style="z-index: 1000 !important"
                    data-toggle="tooltip"
                    data-placement="top"
                    :title="element.title"
                    @click="selectPlace(index, element)"
                  >
                    <i class="fas fa-arrows-alt"></i>
                  </button>
                  <!-- <button
                    type="button"
                    class="btn btn-primary"
                    style="z-index: 1000 !important"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="element.title"
                    @click="openModalPlace(index, element)"
                  >
                    <i class="fas fa-hand-pointer"></i>
                  </button> -->
                </VueDragResize>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-md-12 text-center">
        <i class="fas fa-spinner fa-spin fa-5x"></i>
      </div>
    </div>
  </div>
</template>

<script>
import VueDragResize from "vue-drag-resize";

export default {
  name: "example",
  data: function () {
    return {
      loaded: false,
      workstation: {
        title: "",
        photo: "",
        blueprint: "",
        equipments: [],
        places: [
          {
            details: [],
          },
        ],
      },
      checkeds: [],
      details: {
        selected: "",
      },
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      selected: "",
      isSelected: false,
      elements: [],
      elementSelected: [],
      card_height: 0,
      workstation_id: "",
      delay: 700,
      clicks: 0,
      timer: 1000,
    };
  },
  components: {
    VueDragResize,
  },
  methods: {
    onLoaded() {
      const self = this;
      self.elements = self.sizeTreatment(self.workstation.places);
    },

    getWorkstation: function () {
      const self = this;
      let id = self.$route.params.id;
      const api =
        self.$store.state.api + "workstations/" + id + "?with[]=places";
      self.$http
        .get(api)
        .then((response) => {
          self.workstation = response.data.data[0];
        })
        .then(() => {
          self.loaded = true;
        })
        .catch((error) => {
          self.$error(
            "Ocorreu um erro ao buscar as informações da Estação de Trabalho"
          );
        });
    },
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "workstation_details/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    resize: function (newRect, index) {
      this.elements[index].width = newRect.width;
      this.elements[index].height = newRect.height;
      this.elements[index].top = newRect.top;
      this.elements[index].left = newRect.left;
    },
    addPlace: function () {
      const self = this;
      let background = $(".image-size");
      let obj = {
        left: 0,
        top: 0,
        width: 30,
        height: 30,
        active: false,
        details: self.workstation.details_id,
        workstation_id: self.workstation.id,
        screen_width: background.width(),
        screen_height: background.height(),
      };
      self.elements.push(obj);
    },
    openModalPlace() {
      $("#modalPlace").modal("show");
    },
    selectPlace(index, element) {
      const self = this;
      if (element.id != self.elementSelected.id) {
        this.selected = index;
        this.elementSelected = element;
        this.isSelected = true;

        this.checkeds = [];

        element.details.forEach((el) => {
          self.checkeds.push(el);
        });
      } else {
        this.selected = "";
        this.elementSelected = {};
        this.isSelected = false;
        this.checkeds = [];
      }

      // $("#modalPlace").modal("show");
    },
    savePosition(element) {
      console.log(element);
      console.log(this.checkeds);
      this.workstation.places[this.selected].details = this.checkeds;
      this.save();
    },
    removeComponent(index) {
      let self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            if (this.workstation.places[index].id == undefined) {
              this.elements.splice(index, 1);
            } else {
              let api =
                self.$store.getters.api +
                "workstations/places/" +
                this.workstation.places[index].id;

              self.$http
                .delete(api)
                .then((response) => {
                  swal("Sucesso", "Registro excluído com sucesso!", "success");
                  this.workstation.places.splice(index, 1);
                  self.elementSelected = {};
                  self.$emit("refresh");
                })
                .catch((error) => {
                  self.$errorMessage(error);
                });
            }
            break;
        }
      });
    },
    save: function () {
      const self = this;
      const api = self.$store.state.api + "workstations/places";

      self.$http
        .post(api, {
          places: self.elements,
        })
        .then((response) => {
          self.$message("Sucesso", "Posições salvas com sucesso", "success");
          self.elements = [];
          self.elementSelected = {};
          self.isSelected = false;
          self.getWorkstation();
          setTimeout(function () {
            self.elements = self.sizeTreatment(self.workstation.places);
            $(function () {
              $('[data-toggle="tooltip"]').tooltip();
            });
          }, 1000);
        })
        .catch((error) => {
          self.$error(error);
        });
    },
    sizeTreatment: function (array) {
      const self = this;
      $.each(array, function (index, value) {
        array[index] = self.calculateDimensions(value);
      });
      return array;
    },
    calculateDimensions: function (obj) {
      let result = {};
      let imageSize = $(".image-size");
      let width = imageSize.width();
      let height = imageSize.height();
      this.card_height = height;

      result.active = false;
      result.top = (obj.top * height) / obj.screen_height;
      result.left = (obj.left * width) / obj.screen_width;
      result.screen_width = width;
      result.screen_height = height;
      result.width = (obj.width * width) / obj.screen_width;
      result.height = (obj.height * height) / obj.screen_height;
      result.workstation_id = obj.workstation_id;
      result.id = obj.id ? obj.id : null;
      result.title = obj.title ? obj.title : null;
      result.details = obj.details ? obj.details : null;

      return result;
    },
    updateElement: function (elem, response) {
      const self = this;
      const api = self.$store.state.api + "machine-equipments/remove";

      self.$http
        .post(api, {
          machine_id: self.$route.params.id,
          equipment_id: elem.equipment_id,
        })
        .then(() => {
          response();
        })
        .catch((error) => {
          self.$error("Não foi possível remover o registro");
        });
    },
  },
  mounted: function () {
    this.getWorkstation();
    this.getWorkstationDetails();

    setTimeout(function () {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 1000);
  },
};
</script>

<style scoped>
.vdr {
  align-items: center;
  background: rgba(13, 80, 139, 0.4);
  /* border: 3px solid #0d508b; */
  border-radius: 20px;
}

.top-container {
  width: 100%;
  height: auto;
  position: relative;
}
.top-container img {
  width: 100%;
  height: auto;
  position: relative;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Workstations/Configuration.vue